import React from "react";

const Header = () => {
  return (
    <header className="jumbotron">
      <h1>Todo App in React</h1>
      <p className="lead">
        Add your task from below field and hit enter or just click on Add Task
      </p>
      <hr className="my-4" />
    </header>
  );
};

export default Header;
